import { createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../app/api";
import { serializeError } from "../../app/shared";
import { ShortFlatUserModel } from "./model/ShortFlatUserModel";

const SLICE_NAME = "helperState";

export const getUserInfo = createAsyncThunk(
  `${SLICE_NAME}/getUserInfo`,
  async (idList: number[], { rejectWithValue }) => {
    try {
      const userInfo: ShortFlatUserModel[] = await request.post(
        "/user/info",
        idList
      );
      return userInfo;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  }
);